// Application API client (legacy-safe adapter)
// NOTE: auth.me() was removed - use useCurrentAppUser hook instead for real user data

async function invokeMockFunction(functionName, params) {
  console.log(`Mock function call: ${functionName}`, params);

  switch (functionName) {
    case "getSupabaseContacts":
    case "getAllContacts":
      return {
        data: {
          success: true,
          contacts: [
            {
              id: "1",
              first_name: "João",
              last_name: "Silva",
              full_name: "João Silva",
              primary_email: "joao.silva@example.com",
              primary_email_value: "joao.silva@example.com",
              primary_phone: "+55 11 98765-4321",
              primary_phone_value: "+55 11 98765-4321",
              status: "active",
              country_of_nationality: "Brazil",
              created_at: "2024-01-15",
            },
            {
              id: "2",
              first_name: "Maria",
              last_name: "Santos",
              full_name: "Maria Santos",
              primary_email: "maria.santos@example.com",
              primary_email_value: "maria.santos@example.com",
              primary_phone: "+55 21 99876-5432",
              primary_phone_value: "+55 21 99876-5432",
              status: "active",
              country_of_nationality: "Brazil",
              created_at: "2024-02-20",
            },
          ],
        },
      };

    case "getCasesSimple":
      return {
        data: {
          success: true,
          cases: [
            {
              id: "1",
              case_type_name: "Divórcio Consensual",
              sales_item_name: "Divórcio",
              status: "in_progress",
              priority: "high",
              created_by_display_name: "João Silva",
              created_at: new Date().toISOString(),
            },
            {
              id: "2",
              case_type_name: "Ação Trabalhista",
              sales_item_name: "Trabalhista",
              status: "pending",
              priority: "urgent",
              created_by_display_name: "Maria Santos",
              created_at: new Date().toISOString(),
            },
            {
              id: "3",
              case_type_name: "Defesa Criminal",
              sales_item_name: "Criminal",
              status: "approved",
              priority: "medium",
              created_by_display_name: "Pedro Costa",
              created_at: new Date().toISOString(),
            },
          ],
        },
      };

    case "getCaseWithDetails":
      return {
        data: {
          success: true,
          case: {
            id: params.case_id || "1",
            case_number: "CASE-2025-0001",
            case_type_name: "Divórcio Consensual",
            status: "in_progress",
            priority: "high",
            created_at: new Date().toISOString(),
            created_by_display_name: "João Silva",
            case_contacts: [
              {
                id: "1",
                contact_id: "1",
                role: "payer",
                label: "Cliente Principal",
                contact: {
                  id: "1",
                  first_name: "João",
                  last_name: "Silva",
                  full_name: "João Silva",
                  primary_email_value: "joao.silva@example.com",
                  primary_phone_value: "+55 11 98765-4321",
                },
              },
            ],
            sales_items: {
              id: "1",
              name: "Divórcio Consensual",
              price: 5000,
              config: {
                roles: [],
              },
            },
            assignments: [],
          },
        },
      };

    case "getSupabaseContact":
      return {
        data: {
          success: true,
          contact: {
            id: params.id || "1",
            first_name: "João",
            last_name: "Silva",
            full_name: "João Silva",
            primary_email_value: "joao.silva@example.com",
            primary_phone_value: "+55 11 98765-4321",
            status: "active",
            date_of_birth: "1990-05-15",
            gender: "male",
            language: "Portuguese",
            country_of_nationality: "Brazil",
            primary_address_line1: "Rua das Flores, 123",
            primary_address_city: "São Paulo",
            created_at: "2024-01-15",
          },
        },
      };

    case "autoGenerateId": {
      const timestamp = Date.now();
      const randomNum = Math.floor(Math.random() * 1000);
      return {
        data: {
          success: true,
          custom_id: `LEAD-${timestamp}-${randomNum}`,
        },
      };
    }

    case "createLead":
      return {
        data: {
          success: true,
          lead: {
            id: `lead_${Date.now()}`,
            lead_id: params.lead_id,
            first_name: params.first_name,
            last_name: params.last_name,
            phone: params.phone,
            source: params.source,
            status: params.status || "new",
            assigned_to: params.assigned_to,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
          },
        },
      };

    default:
      return {
        data: {
          success: true,
          message: `Mock response for ${functionName}`,
        },
      };
  }
}

const functions = new Proxy(
  {},
  {
    get(_, prop) {
      if (prop === "invoke") {
        return async (functionName, params = {}) => invokeMockFunction(functionName, params);
      }

      // Supports direct calls like appClient.functions.syncUsersToSupabase(params)
      return async (params = {}) => {
        const result = await invokeMockFunction(String(prop), params);
        return result?.data;
      };
    },
  },
);

const entities = {
  User: {
    async list() {
      return [
        {
          id: "1",
          name: "Admin User",
          full_name: "Admin User",
          email: "admin@example.com",
          role: "admin",
          position: "Manager",
          status: "active",
        },
        {
          id: "2",
          name: "John Doe",
          full_name: "John Doe",
          email: "john@example.com",
          role: "user",
          position: "Sales",
          status: "active",
        },
      ];
    },
  },
};

export const appClient = {
  functions,
  entities,
  auth: {},
};

